module.exports = __webpack_public_path__ + "static/001-bb5d03ee6125908a37575e957972607a.jpg";